/**
 * ❕NOTE: returns 1 when true is passed
 */
export const getRoundedDiscount = (discount: number) => {
  const parsedDiscount = Number(discount);

  if (Number.isNaN(parsedDiscount)) {
    return 0;
  }

  let roundedNumber = Math.round(parsedDiscount);
  if (roundedNumber < 0) {
    return 0;
  } else if (roundedNumber > 100) {
    return 100;
  }

  return roundedNumber;
};
